import React, { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Typography, Box, Button, ButtonGroup } from "@mui/material";
import { saveUserConfiguration } from "../../util/SaveUserConfigurations";

export default function ReviewSection({
  open,
  data,
  moreData,
  page,
  captureCallbackRef,
  setPage,
  authUser,
  dataSelection,
  cost,
  customFiles,
  setSuccRequestStages,
  setSubmittedConfigObj,
  glbsLoaded,
  productBodyType,
  product,
  companyName,
  isNight = false,
}) {
  const [isOpen, setIsOpen] = useState(open);

  useEffect(() => {
    setIsOpen(open);
  }, [open]);

  const transition = {
    // duration: 0.5, // how long the box resize lasts
    delay: 1, // wait before starting the resize
  };

  return (
    <div
      className="flex h-screen"
      style={{
        position: "absolute",
        zIndex: "9999",
        opacity: page === "review" ? "1" : "0",
        right: "0",
      }}
    >
      <motion.div
        transition={transition}
        initial={{ width: "calc(50vw - 6vh)" }}
        animate={{
          padding: isOpen ? "6vh 3vh 3vh 3vh" : "0px",
          width: isOpen ? "calc(50vw - 6vh)" : "20px",
          transition: { duration: 0.4, ease: "easeInOut" },
        }}
        style={{
          backgroundColor: isNight ? "#566176" : "white",
          color: isNight ? "#eef2f7" : "inherit",
          transition: "color 0.35s ease, background-color 0.35s ease",
          overflow: "hidden",
          height: "calc(100vh - calc(6vh + 8px))",
          // padding: "3vh",
          boxSizing: "border-box",
        }}
      >
        <AnimatePresence>
          {isOpen && (
            <motion.div
              transition={transition}
              key="content"
              initial={{ opacity: 0 }}
              animate={{ opacity: 1, transition: { duration: 0.3 } }}
              exit={{ opacity: 0, transition: { duration: 0.3 } }}
              className="p-4"
            >
              <motion.div transition={transition} layout={false}>
                {/* <div
                  style={{
                    height: "1px",
                    width: "100%",
                    backgroundColor: isNight ? "#707a90" : "#0000000d",
                    transition: "background-color 0.35s ease",
                    marginBottom: "3vh",
                  }}
                ></div> */}
                <Typography
                  fontWeight="bold"
                  textAlign={"start"}
                  sx={{ fontSize: "calc(0.72rem + var(--large-screen-font-bump))", paddingBottom: "5px" }}
                >
                  {"REQUEST SUMMARY"}
                </Typography>
                <div style={{ height: "23px" }}></div>
                <div
                  style={{
                    height: "1px",
                    width: "100%",
                    backgroundColor: "#0000000d",
                    marginBottom: "23px",
                  }}
                ></div>
                <Typography
                  fontWeight="bold"
                  textAlign={"start"}
                  sx={{ fontSize: "calc(0.72rem + var(--large-screen-font-bump))", paddingBottom: "5px" }}
                >
                  {data.title}
                </Typography>
                {data.rows.map((row, i) => (
                  <Box
                    key={i}
                    display="flex"
                    justifyContent="space-between"
                    marginBottom="0px"
                    marginTop="12px"
                    fontSize={"calc(0.68rem + var(--large-screen-font-bump))"}
                    // mt={1}
                  >
                    <span>{row.label}</span>{" "}
                    <span style={{ fontWeight: "bold" }}>{row.value}</span>
                  </Box>
                ))}
              </motion.div>
              <div style={{ height: "23px" }}></div>
              <div
                style={{
                  height: "1px",
                  width: "100%",
                  backgroundColor: isNight ? "#707a90" : "#0000000d",
                  transition: "background-color 0.35s ease",
                  marginBottom: "23px",
                }}
              ></div>
              <motion.div transition={transition} layout={false}>
                <Typography
                  fontWeight="bold"
                  textAlign={"start"}
                  sx={{ fontSize: "calc(0.72rem + var(--large-screen-font-bump))", paddingBottom: "5px" }}
                >
                  {moreData.title}
                </Typography>
                {moreData.rows.map((row, i) => (
                  <Box
                    key={i}
                    display="flex"
                    justifyContent="space-between"
                    marginBottom="0px"
                    marginTop="12px"
                    fontSize={"calc(0.68rem + var(--large-screen-font-bump))"}
                    // mt={1}
                  >
                    <span>{row.label}</span>{" "}
                    <span style={{ fontWeight: "bold" }}>{row.value}</span>
                  </Box>
                ))}
              </motion.div>
            </motion.div>
          )}
          {/* <Button>SEND REQUEST</Button> */}
          <ButtonGroup
            fullWidth
            sx={{
              position: "absolute",
              left: 0,
              bottom: "3vh",
              padding: "3vh",
              boxSizing: "border-box",
            }}
          >
            <Button
              disableRipple
              variant="text"
              sx={{
                color: isNight ? "#eef2f7" : "#CE1126",
                transition: "color 0.35s ease",
                top: "23px",
                height: "40px",
                borderRadius: 0,
                fontSize: "calc(0.72rem + var(--large-screen-font-bump))",
                border: "0px !important",
                fontWeight: "bold",
                backgroundColor: "transparent !important",
                "&:hover": {
                  backgroundColor: "transparent !important",
                },
                "&:active": {
                  backgroundColor: "transparent !important",
                  boxShadow: "none !important",
                },
              }}
              onClick={() => {
                setPage("configurator");
              }}
            >
              <Box
                sx={{
                  marginRight: "20px",
                  height: "10px",
                  width: "10px",
                }}
                position={"relative"}
              >
                <img
                  style={{
                    position: "absolute",
                    filter: isNight ? "brightness(0) invert(1)" : "none",
                    transition: "filter 0.35s ease",
                  }}
                  src={"Assets/backwards-arrow-red.svg"}
                  alt="backwards-arrow"
                  height={"10px"}
                />
              </Box>
              <Typography
                marginRight={"20px"}
                fontSize={"calc(0.72rem + var(--large-screen-font-bump))"}
                fontWeight={"bold"}
              >
                BACK
              </Typography>
            </Button>

            <Button
              variant="contained"
              onClick={() => {
                // 🔥 Prevent clicking before ready
                if (!glbsLoaded || !captureCallbackRef.current) {
                  console.warn("Capture not ready yet.");
                  return;
                }

                const Base64Images = captureCallbackRef.current();

                saveUserConfiguration(
                  authUser?.id_token,
                  product,
                  productBodyType,
                  companyName,
                  dataSelection,
                  cost,
                  Base64Images,
                  customFiles, // to be replaced with custom files
                  true,
                  null,
                  setSubmittedConfigObj,
                );

                //                 user_id,
                // product,
                // productBodyType,
                // companyName,
                // config_,
                // cost,
                // Base64Images,
                // customFiles,
                // submitted = false,
                // selectedByUser

                setSuccRequestStages("sent");
              }}
              sx={{
                backgroundColor: "#CE1126",
                transition: "background-color 0.35s ease",
                top: "23px",
                height: "40px",
                borderRadius: "0px",
                color: "white",
                border: "0px !important;",
              }}
            >
              <Typography
                marginLeft={"20px"}
                fontSize={"calc(0.72rem + var(--large-screen-font-bump))"}
                fontWeight={"bold"}
              >
                SEND REQUEST
              </Typography>

              <img
                style={{ marginLeft: "20px" }}
                src="Assets/forward-arrow-white.svg"
                alt="forward-arrow"
                height={"10px"}
              />
            </Button>
          </ButtonGroup>
        </AnimatePresence>
      </motion.div>
    </div>
  );
}
